import { environment } from '@env/environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { AuthState } from './auth/auth.models';
import { authReducer } from './auth/auth.reducer';
import { debug } from './meta-reducers/debug.reducer';
import { initStateFromLocalStorage } from './meta-reducers/init-state-from-local-storage.reducer';
import { RouterStateUrl } from './router/router.state';
import { MasterViewState } from '@app/shared/modules/master-view-state/master-view.state';
import { gridsterReducer } from '@app/shared/modules/master-view-state/master-view.reducer';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  router: routerReducer,
  masterWidget: gridsterReducer
};

export const metaReducers: MetaReducer<AppState>[] = [initStateFromLocalStorage];

if (!environment.production) {
  metaReducers.unshift(debug);
}

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const selectGridsterState = createFeatureSelector<MasterViewState>('masterWidget');

export interface AppState {
  auth: AuthState
  router: RouterReducerState<RouterStateUrl>
  masterWidget: MasterViewState
}

export interface State extends AppState {
  app: AppState
}
